/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useState } from 'react';
import styled from 'styled-components';
import {
  Visibility as DefVisibility,
  VisibilityOff as DefVisibilityOff,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Input, InputProps } from './Input';

export type PasswordFieldProps = InputProps;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PasswordField = ({ type, ...props }: PasswordFieldProps) => {
  const [masked, setMasked] = useState(true);

  return (
    <Input
      type={masked ? 'password' : 'text'}
      InputProps={{
        endAdornment: (
          <IconButton edge="end" onClick={() => setMasked(!masked)}>
            {masked ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        ),
      }}
      {...props}
    />
  );
};

const commonIconStyles = () => `cursor: pointer;`;

const Visibility = styled(DefVisibility)`
  ${commonIconStyles}
`;

const VisibilityOff = styled(DefVisibilityOff)`
  ${commonIconStyles}
`;

export { PasswordField };
